import {authAPI} from '@/api/restfulAPI'
import {Base64} from 'js-base64'

export const TOKEN_STG_KEY = 'composerToken'

export function rememberToken (token) {
  localStorage.setItem(TOKEN_STG_KEY, token)
}

export function getToken () {
  var strCookie = document.cookie
  var arrCookie = strCookie.split('; ')
  for (var i = 0; i < arrCookie.length; i++) {
    var arr = arrCookie[i].split('=')
    if (arr[0] === 'EIToken') {
      return arr[1]
    }
  }
  return null
}

export function setToken (token) {
  document.cookie = token
}

// export function setSession (name, value) {
//   sessionStorage.setItem(name, value)
// }

// export function getSession (name) {
//   return sessionStorage.getItem(name)
// }

export function checkToken () {
  let p = new Promise((resolve, reject) => {
    authAPI.checkToken(getToken()).then(() => {
      resolve()
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

export function setCookie (cname, cvalue, exdays) {
  var d = new Date()
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + encodeURI(cvalue) + '; ' + expires
}

export function clearToken () {
  document.cookie = 'EIToken=EIToken; expires=Thu, 01 Jan 1970 00:00:00 GMT'
  document.cookie = 'EIName=EIName; expires=Thu, 01 Jan 1970 00:00:00 GMT'
}

export function getCookie (cname) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1)
    if (c.indexOf(name) !== -1) return decodeURI(c.substring(name.length, c.length))
  }
  return ''
}

// 删除Cookie
export function delCookie (name) {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = getCookie(name)
  document.cookie = name + "=" + cval + ";  expires=" + exp.toGMTString()
}

export function getAuthenFromToken () {
  let tokenStr = getToken()
  return `Bearer ${tokenStr}`
}

export function getExpFromToken () {
  let exp = null
  let tokenStr = getToken()
  if (tokenStr !== null && tokenStr !== '') {
    let thokenSubStr = tokenStr.split('.')[1]
    let payloadStr = window.atob(thokenSubStr)
    let tokenObj = JSON.parse(payloadStr)
    exp = tokenObj.exp
  }
  return exp
}

export function getUserInfoFromToken () {
  const ADMIN_ROLE = 'admin'
  const GUEST_ROLE = 'guest'
  let user = null
  let token = getToken()
  if (token != null) {
    let payloadBStr = token.split('.')[1]
    if (payloadBStr != null) {
      let payloadStr = Base64.decode(payloadBStr)
      let payload = JSON.parse(payloadStr)
      user = {
        id: payload.id,
        name: payload.username,
        // role: payload.role === 1 ? ADMIN_ROLE : GUEST_ROLE,
        role: payload.role === 'srpUser' ? GUEST_ROLE : ADMIN_ROLE,
        loginTs: payload.iat
      }
    }
  }
  return user
}

export function getParamFromURL (param) {
  var url = window.location.toString()
  var str = ''
  var strValue = ''
  if (url.indexOf('?') !== -1) {
    var ary = url.split('?')[1].split('&')
    for (var i = 0; i < ary.length; i++) {
      str = ary[i].split('=')[0]
      if (str === param) {
        strValue = decodeURI(ary[i].split('=')[1])
        break
      }
    }
  }
  return strValue
};



// WEBPACK FOOTER //
// ./src/js/tokenProcess.js